import { FC } from 'react';
import Loader from 'react-loader-spinner';

import { BLUE_COLOR_6 } from 'shared/constants/colors';
import { LoaderWrapper } from './style';
import { TCustomLoader } from './types';

const CustomLoader: FC<TCustomLoader> = ({ style }) => {
  return (
    <LoaderWrapper style={style}>
      <Loader type="Oval" color={BLUE_COLOR_6} height={50} width={50} />
    </LoaderWrapper>
  );
};

export default CustomLoader;
